import type { SVGProps } from "react";

export function CancelCircle({
  props,
  fillColor = "white",
  opacity = "0.4",
}: {
  props?: SVGProps<SVGSVGElement>;
  fillColor?: string;
  opacity?: string;
}) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity={opacity}
        d="M0.9375 9C0.9375 13.4528 4.5472 17.0625 9 17.0625C13.4528 17.0625 17.0625 13.4528 17.0625 9C17.0625 4.5472 13.4528 0.9375 9 0.9375C4.5472 0.9375 0.9375 4.5472 0.9375 9Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7803 6.21969C12.0732 6.51259 12.0732 6.98746 11.7803 7.28035L10.0606 9L11.7803 10.7197C12.0732 11.0125 12.0732 11.4874 11.7803 11.7803C11.4874 12.0732 11.0126 12.0732 10.7197 11.7803L8.99985 10.0606L7.28031 11.78C6.98741 12.0729 6.51253 12.0729 6.21965 11.78C5.92677 11.4871 5.92678 11.0122 6.21969 10.7194L7.93912 9L6.21969 7.28064C5.92678 6.98776 5.92677 6.51289 6.21965 6.21998C6.51253 5.92708 6.98741 5.92706 7.28031 6.21994L8.99985 7.93935L10.7197 6.21965C11.0126 5.92677 11.4874 5.92678 11.7803 6.21969Z"
        fill="white"
      />
    </svg>
  );
}
